import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page9 = ({
  Earning,
  Deductions,
  Benefits,
  Salarydata,
  RowIDdata,
  sign
}) => {
  const headerStyle = {
    backgroundColor: "#d9d9d9",
    fontWeight: "bold",
    
  };

 
  let EarningData = Earning.filter((val) => /^[A-Za-z]/.test(val?.componentName)) 
    .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); 

  let Deductiondata = Deductions.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ) 
    .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); 
  
  let Benefitsdata = Benefits.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ) 
    .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); 

    const capitalizeFirstLetter = (str) => {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };
    const candidateName = capitalizeFirstLetter(RowIDdata?.candidateName);
  const totalRowStyle = {
    backgroundColor: "#d9d9d9",
  };
  function formatNameInitials(name) {
    if (!name) return "";
 
      const parts = name.trim().toLowerCase().split(" ");
        const Name = parts
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
          
    return  Name;
  }
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <p className="bol" style={{ textDecoration: "underline" }}>
          Annexure A
        </p>
        <div
        style={{
          display: "flex",
          width: "88%",
          margin: "10px 40px",
          alignItems: "flex-start",
        }}
        >
          <div>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Name:</span>{" "}
              {formatNameInitials(candidateName)}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Designation:</span>{" "}
              {RowIDdata?.position}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Department :</span>{" "}
              {RowIDdata?.department}
            </p>
          </div>

          <div
            style={{
              marginLeft: "auto",
              textAlign: "right",
            }}
          >
            <p className="para">
              <span style={{ fontWeight: "800" }}>Location:</span> Chennai
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Employee Code:</span>{" "}
              {Salarydata?.empCode}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Grade:</span> A
            </p>
          </div>
        </div>
        <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
          style={{margin:'24px 30px 0px 40px',width:'88%',marginTop:'20px'}}
          // contentEditable
          suppressContentEditableWarning={true}
        >
          <thead>
            <tr style={headerStyle}>
              <td style={{ paddingLeft: "7px" }} >CTC ALLOCATION</td>
              <td style={{ paddingLeft: "7px" }}>{Salarydata?.ctc ? (Salarydata?.ctc / 12)?.toFixed(2) : "0"}</td>
              <td style={{ paddingLeft: "7px" }}> {Salarydata?.ctc || 0}</td>
            </tr>

            <tr style={headerStyle}>
              <td style={{ paddingLeft: "7px" }}>Salary Components</td>
              <td style={{ paddingLeft: "7px" }}>Monthly</td>
              <td style={{ paddingLeft: "7px" }}>Annually</td>
            </tr>
          </thead>
          <tbody>
            {EarningData.length > 0 && (
              <>
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }} className="para">
                    <b>Fixed (A)</b>
                  </td>
                </tr>
                <tr >
                  <td style={{ paddingLeft: "7px" }}>{EarningData[0]?.componentName || ""}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[0]?.monthly || 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[0]?.yearly || 0}</td>
                </tr>
                <tr>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[1]?.componentName || ""}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[1]?.monthly || 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[1]?.yearly || 0}</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td>
                    <b style={{marginLeft:"5px"}}>Total (A)</b>
                  </td>
                  <td><b>{(EarningData[0]?.monthly && EarningData[1]?.monthly) ? EarningData[0]?.monthly + EarningData[1]?.monthly : 0}</b> </td>
                  <td><b>{(EarningData[0]?.yearly && EarningData[1]?.yearly) ? EarningData[0]?.yearly + EarningData[1]?.yearly : 0}</b></td>
                </tr>
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    <b>Reimbursement Basket (B)</b>
                  </td>
                </tr>
                <tr>
                <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.componentName || ""}</td>
                <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.monthly || 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.yearly || 0}</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td>
                    <b style={{marginLeft:"5px"}}>Total (B)</b>
                  </td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.monthly ?? 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.yearly ?? 0}</td>
                </tr>
                <tr>
                  <td>
                    <b style={{ marginLeft: "5px" }}>{EarningData[3]?.componentName || ""} (C)</b>
                  </td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[3]?.monthly || 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{EarningData[3]?.yearly || 0}</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td>
                    <b style={{ marginLeft: "5px" }}>Gross (D) = (A+B+C)</b>
                  </td>
                  <td><b>{Salarydata?.gross ?? 0}</b> </td>
                  <td><b>{((Salarydata?.gross ?? 0) * 12)?.toFixed(2)}</b> </td>
                </tr>
            </>
            )}

            {Deductiondata.length > 0 && (
              <>
                <tr>
                  <td colSpan="3">
                    <b style={{ marginLeft: "5px" }}>Deductions</b>
                  </td>
                </tr>
                {Deductiondata.length > 1 && (
                <tr>
                  <td style={{ paddingLeft: "7px" }}>{Deductiondata[1]?.componentName || ""}</td>
                  <td style={{ paddingLeft: "7px" }}>{Deductiondata[1]?.monthly ?? 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{Deductiondata[1]?.yearly ?? 0}</td>
                </tr>
                )}
                <tr>
                  <td style={{ paddingLeft: "7px" }}>{Deductiondata[0]?.componentName || ""}</td>
                  <td style={{ paddingLeft: "7px" }}>{Deductiondata[0]?.monthly ?? 0}</td>
                  <td style={{ paddingLeft: "7px" }}>{Deductiondata[0]?.yearly ?? 0}</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td>
                    <b style={{ marginLeft: "5px" }}>Total Deductions</b>
                  </td>
                  {/* <td>{Deductiondata[1]?.monthly + Deductiondata[0]?.monthly}</td> */}
                  <td><b>{Salarydata?.totalDeductions ?? 0}</b></td>
                  <td><b>{(Deductiondata[1]?.yearly && Deductiondata[0]?.yearly) ? (Deductiondata[1]?.yearly + Deductiondata[0]?.yearly)?.toFixed(2) : 0}</b></td>
                </tr>
              </>
            )}
            {Benefitsdata.length > 0 && (
              <>
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    <b >Benefits</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[1]?.componentName}</td>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[1]?.monthly}</td>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[1]?.yearly}</td>
                </tr>
                <tr>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[0]?.componentName}</td>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[0]?.monthly}</td>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[0]?.yearly}</td>
                </tr>
                <tr>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[2]?.componentName}</td>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[2]?.monthly}</td>
                  <td style={{ paddingLeft: "7px" }}>{Benefitsdata[2]?.yearly}</td>
                </tr>
                <tr>
                  <td>
                    <b style={{ marginLeft: "5px" }}>Benefits Total (E)</b>
                  </td>
                  <td style={{ paddingLeft: "7px" }}><b>{Salarydata?.totalBenefits}</b></td>
                  <td style={{ paddingLeft: "7px" }}><b>{Salarydata?.totalBenefits * 12}</b></td>
                </tr>
              </>
            )}
            <tr>
              <td>
                <b style={{ marginLeft: "5px" }}>Monthly & Annual CTC </b>
              </td>
              <td style={{ paddingLeft: "7px" }}><b>{((Salarydata?.ctc ?? 0) / 12)?.toFixed(2)}</b></td>

              <td style={{ paddingLeft: "7px" }}><b>{Salarydata?.ctc ?? 0}</b></td>
            </tr>
            <tr>
              <td>
                <b style={{ marginLeft: "5px" }}>Net Take Home </b>
              </td>
              <td style={{ paddingLeft: "7px" }}><b>{Salarydata?.netPay ?? 0}</b></td>
              <td style={{ paddingLeft: "7px" }}> <b>{(Salarydata?.netPay ?? 0) * 12}</b></td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            display: "flex",
            width: "80%",
            justifyContent: "space-between",
            marginTop: "10px"
          }}
        >
          <div style={{ marginLeft: "40px" }}>
            <div
              style={{
                marginTop: "15px",
                width: "150px",
                height: "50px",
                borderBottom: "1px solid #000",
                backgroundColor: "transparent",
              }}
            >
              {/* <img src={sign} width={"150px"}/> */}
            </div>            
            <p className="boldsoff">HR Manager</p>
          </div>
          <div style={{marginLeft: "0px" }}>
            <p className="bolds">I accept the above offer</p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Name:</span>{" "}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Date:</span>{" "} 
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Signature:</span>{" "} 
            </p>
          </div>
        </div>
      </div>
    </ReusablePDFLayout>
  );
};
